const actionTypes = {
  INIT_PAYMENT_SUBJECTS: Symbol('INIT_PAYMENT_SUBJECTS'),
  INIT_CONSUME_SUBJECTS: Symbol('INIT_CONSUME_SUBJECTS'),
  INIT_BILL_SUBJECTS: Symbol('INIT_BILL_SUBJECTS'),
  SET_BILL_STATS_LOADING: Symbol('SET_BILL_STATS_LOADING'),
  INIT_BILL_STATS: Symbol('INIT_BILL_STATS'),
  RESET_BILL_STATS: Symbol('RESET_BILL_STATS'),
  SET_ORDER_BILL_STATUS: Symbol('SET_ORDER_BILL_STATUS'),
  SET_ORDER_BILL_NO: Symbol('SET_ORDER_BILL_NO'),
  SET_BILL_LIST_LOADING: Symbol('SET_BILL_LIST_LOADING'),
  INIT_BILL_LIST: Symbol('INIT_BILL_LIST'),
  RESET_BILL_LIST: Symbol('RESET_BILL_LIST'),
  UPDATE_BILL_LIST: Symbol('UPDATE_BILL_LIST'),
  SET_LIST_FILTER_PARAMS: Symbol('SET_LIST_FILTER_PARAMS'),
  SET_SELECTED_BILLS: Symbol('SET_SELECTED_BILLS'),
  SET_SELECTED_BILL_IDS: Symbol('SET_SELECTED_BILL_IDS'),
  SET_BILL_ROOMS_LOADING: Symbol('SET_BILL_ROOMS_LOADING'),
  INIT_BILL_ROOMS: Symbol('INIT_BILL_ROOMS'),
  RESET_BILL_ROOMS: Symbol('RESET_BILL_ROOMS'),
  SET_SELECTED_ROOM: Symbol('SET_SELECTED_ROOM'),
  SET_SETTLEMENT_NO: Symbol('SET_SETTLEMENT_NO'),
  SET_SETTLEMENT_ACTION: Symbol('SET_SETTLEMENT_ACTION'),
  SET_ORDER_MASTER: Symbol('SET_ORDER_MASTER'),
  INIT_MASTER_INFO: Symbol('INIT_MASTER_INFO'),
};

export default actionTypes;
